<template>
  <div style="padding: 0 10px">
    <From @search="searchCall" @print="print1"/>
    <WmsTable :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall" :isPagination="query" >
      <ImgView slot="productImgAction" slot-scope="{text, record, index}" :src="text"></ImgView>
    </WmsTable>
  </div>
</template>

<script>
import { excelExport } from "@/utils/tools";
import Calendar from "@/utils/calendar";
import From from "@/views/inventoryDetails/inventory/components/From";
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import { columns } from "@/views/inventoryDetails/inventory/indexData";
import { stockPage } from "@/apis/inventoryDetails";
export default {
  title: "仓库库存",
  name: "Inventory",
  components: {
    WmsTable,
    ImgView,
    From
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      dataSource: [],
      formInline: {}
    }
  },
  methods: {
    searchCall: function (fromData) {
      this.formInline = fromData
      this.query.current = 1
      this.query.total = 1
      this.getDataSource()
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload
      this.query.current = current
      this.query.pageSize = pageSize
      this.getDataSource()
    },
    getDataSource: function () {
      let params = {
        // checkingShelvFlag: 1,
        // combinationProductItemFlag: 1,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      };
      stockPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records.map((item) => {
            return {
              ...item,
              checked: item.checked + item.allIncludeChecked,
              freezed: item.freezed + item.allIncludeFreezed
            }
          });
          this.query.total = data.total;
        }
      });
    },
    print1() {
      const date = Calendar.d1(Date.now());
      excelExport({
        headers: [
          {
            title: "店铺名",
            dataIndex: "customerShopName",
            key: "customerShopName",
          },
          {
            title: "商品SKU",
            dataIndex: "shopProductSku",
            key: "shopProductSku",
          },
          {
            title: "商品数量",
            dataIndex: "checked",
            key: "checked",
          },
          {
            title: '冻结数量',
            dataIndex: 'freezed',
            key: 'freezed',
          },
        ],
        contents: this.dataSource,
        fileName: date + "仓库库存",
      });
    }
  }
}
</script>

<style scoped>
</style>